import { IconCloseMedium } from 'icons/components/IconCloseMedium'
import { cx } from 'utils/cx'

import styles from './Tag.module.scss'

type TagVariants = 'default' | 'floating' | 'withClose' | 'withIcon'

type TagProps = {
	readonly label: string
	readonly variant?: TagVariants
	readonly icon?: React.ReactNode
	readonly onClick?: () => void
	readonly microData?: { itemProp: string }
	readonly className?: string
}

const wrapperStyles = {
	default: cx(styles.wrapper, styles.background, styles.body),
	floating: cx(styles.wrapper, styles.floating, styles.body),
	withClose: cx(styles.wrapper, styles.background, styles.button, styles.body),
	withIcon: cx(styles.wrapper, styles.background, styles.withIcon, styles.body),
}

export function Tag({
	onClick,
	label,
	variant = 'default',
	microData,
	icon,
	className,
}: TagProps) {
	if (variant === 'withClose') {
		return (
			<button
				type='button'
				className={cx(wrapperStyles.withClose, className)}
				onClick={onClick}
			>
				<span className={styles.label} {...microData}>
					{label}
				</span>
				<IconCloseMedium width={12} height={12} className={styles.iconClose} />
			</button>
		)
	}

	if (variant === 'withIcon') {
		return (
			<div className={cx(wrapperStyles.withIcon, className)}>
				{icon}
				<span className={styles.label} {...microData}>
					{label}
				</span>
			</div>
		)
	}

	return (
		<span
			className={cx(wrapperStyles[variant], styles.label, className)}
			{...microData}
		>
			{label}
		</span>
	)
}
